export const staticMetaProps = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/blogs/`,
  seoTitle: 'Блоги риэлторов и других специалистов рынка недвижимости России - ЦИАН',
  seoDescription: `ЦИАН - авторские колонки, блоги специалистов рынка недвижимости, блоги риэлторов. Обсуждения, комментарии.`,
  seoKeywords: 'авторские колонки, блоги специалистов рынка недвижимости, блоги риэлторов',
});

const staticMetaPropsSpecialist = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/blogs-specialist/`,
  seoTitle: 'Специалист-специалисту - блог - ЦИАН',
  seoDescription: `Специалист-специалисту - блог, полезная информация о недвижимости. Вся информация о для специалиста в блоге - ЦИАН.`,
  seoKeywords: 'Специалист-специалисту, блог, циан',
});

const staticMetaPropsMarketTrend = (subdomain: string) => ({
  seoUrl: `https://www.cian.ru/blogs-tendentsiy-rynka/`,
  seoTitle: 'Тенденции рынка недвижимости - блог - ЦИАН',
  seoDescription: `Тенденции рынка недвижимости - блог, полезная информация о недвижимости.
    Вся информация о тенденциях рынка в блоге - ЦИАН.`,
  seoKeywords: 'Тенденции рынка, блог, циан',
});

export const staticMetaPropsArray = [{
    type: '',
    data: staticMetaProps,
  }, {
    type: 'specialist',
    data: staticMetaPropsSpecialist,
  }, {
    type: 'market_trend',
    data: staticMetaPropsMarketTrend,
  }];
